import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { DialogToastComponent } from '../components/dialog-toast/dialog-toast.component';

@Injectable({
  providedIn: 'root'
})
export class NoticeService {

  timer: any = null;
  constructor(public dialog: MatDialog) { }
  toast(message: string, type: string, duration:number = 5000) {
    const dialogRef = this.dialog.open(DialogToastComponent, {
      data: { message, type, duration },
      panelClass: 'toast-dialog',
      position: { top: "100px" }
    });
    dialogRef.afterClosed().subscribe(result => {
     this.timer = null;
    });
   this.timer = setTimeout(() => {
      dialogRef.close();
    }, duration);

  }
}
